<script lang="ts">
  import { Button, Image } from "sveltestrap";
  import data from "../../../Data/FileManager/FileManager.json"
  import FeatherIcon from "svelte-feather-icon";
  import { Pricingplan } from "../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/dashboard"

</script>
<ul>
    <li>
      <Button outline color="primary" >
        <FeatherIcon icon="grid" />{Pricingplan}
      </Button>
    </li>
    {#each data.pricingdata as pricngItem}
      <li>
        <div class="pricing-plan">
          <h6>{pricngItem.title}</h6>
          <h5>{pricngItem.header}</h5>
          <p>{pricngItem.space}</p>
          <Button outline color="primary" size="xs">{pricngItem.Selected}</Button>
          <Image class="bg-img" src="{imgPath}/{pricngItem.img}" />
        </div>
      </li>
    {/each}
</ul>